import {
  Squares2X2Icon,
  PresentationChartLineIcon,
  ChartBarIcon,
  FolderOpenIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

/**
 * The Business Intelligence app-strip section: every member-facing analytics
 * dashboard and the financial reports in one place. Visibility is purely
 * permission-driven per item — the section (sidebar and app-strip icon)
 * collapses on its own when none of the children survive filtering.
 *
 * Total Addressable Market deliberately appears BOTH here and in Lead
 * Generation: stage members reach it here without seeing Lead Generation,
 * while existing lead-gen customers keep finding it where it has always
 * been. Same page component, two routes.
 */
const navigation: NavigationItem[] = [
  {
    name: "Sales and Customer Dashboard",
    href: "/business-intelligence/sales-and-customer-dashboard",
    icon: Squares2X2Icon,
    current: false,
    internalName: "dashboards_sales_customer",
    permissions: ["stochastic-dashboard"],
  },
  {
    name: "KPI Dashboard",
    href: "/business-intelligence/kpi-dashboard",
    icon: PresentationChartLineIcon,
    current: false,
    internalName: "dashboards_member",
    permissions: ["kpi-dashboard"],
  },
  {
    name: "Total Addressable Market",
    href: "/business-intelligence/total-addressable-market",
    icon: ChartBarIcon,
    current: false,
    internalName: "dashboards_total_addressable_market",
    permissions: ["stochastic-total-addressable-market"],
  },
  {
    name: "Financial Reports",
    href: "/business-intelligence/financial-reports",
    icon: FolderOpenIcon,
    current: false,
    internalName: "financial_reports",
    permissions: [
      "financial-reports-monthly-balance",
      "financial-reports-p-and-l-report-builder",
      "financial-reports-transaction-list",
    ],
    children: [
      {
        name: "Monthly Balance Sheet",
        href: "/business-intelligence/financial-reports/monthly-balance-sheet",
        icon: ChartBarIcon,
        current: false,
        internalName: "monthly_balance_sheet",
        permissions: ["financial-reports-monthly-balance"],
      },
      {
        name: "Profit and Loss",
        href: "/business-intelligence/financial-reports/profit-and-loss-builder",
        icon: CurrencyDollarIcon,
        current: false,
        internalName: "profit_and_loss_builder",
        permissions: ["financial-reports-p-and-l-report-builder"],
      },
      {
        name: "Transaction List",
        href: "/business-intelligence/financial-reports/transaction-list",
        icon: TableCellsIcon,
        current: false,
        internalName: "transaction_list",
        permissions: ["financial-reports-transaction-list"],
      },
    ],
  },
];

const dashboardsConfig = {
  sectionName: "dashboards",
  defaultRoute: "/business-intelligence/sales-and-customer-dashboard",
  navigation,
};

export default dashboardsConfig;
